import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import MotivoRechazo from './MotivoRechazo';
import ACCESS from '../../../ACCESS.js';

class MotivosRechazo extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'rechazo-motivo/filter', deleteUrl: 'rechazo-motivo/delete', deleteField: 'rechazo_motivo_nombre', modUrl: '/Catalogo/MotivoRechazo' },
      TableOp.Table('Motivos de Rechazo', [
        { label: 'Clave', id: 'rechazo_motivo' },
        { label: 'Descripcion', id: 'rechazo_motivo_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_MOTIVOS_DE_RECHAZO.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_MOTIVOS_DE_RECHAZO.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
        {
             
          <MotivoRechazo  onSave={() => {this.table()}}></MotivoRechazo>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(MotivosRechazo)